//Nav var Toggle
const handleToggleNavbar = () => {
  const navElement = document.getElementById('header-nav')
  if(navElement)
    navElement.classList.toggle('open')
}


//Banner slider
const handleSlideNext = section_id => handleSlide(section_id, 1)
const handleSlideBack = section_id => handleSlide(section_id, -1)

const handleSlide = (section_id, direction) => {
  const bannerSlideElement = document.getElementById(section_id)
  const items = Array.from(bannerSlideElement.children)
  const qty_items = items.length
  console.log(qty_items);
  
  const current_item_index = parseInt(bannerSlideElement.getAttribute('aria-valuenow'))
  const next_item_index = current_item_index+direction < 0 ? qty_items-1 : (current_item_index+direction) % qty_items
  

  bannerSlideElement.setAttribute("aria-valuenow", next_item_index)

  const current_item = items[current_item_index]
  const next_item = items[next_item_index]

  addClass(current_item, 'hide-slide_'+direction.toString())
  setTimeout(()=>{
    current_item.classList.remove('hide-slide_'+direction.toString())
    addClass(current_item, 'hide')
  }, 500)

  next_item.classList.remove('hide')
  addClass(next_item, 'display-slide_'+direction.toString())
  setTimeout(()=>{
    next_item.classList.remove('hide', 'display-slide_'+direction.toString())
  }, 500)
}


//Carousel
const carouselWidth = document.body.getBoundingClientRect().width
Array.from(document.getElementsByClassName("carousel")).forEach(element => {
  element.setAttribute("aria-valuemin", (carouselWidth / 200).toFixed(0))
})

/**
 * @param {Element} element 
 * @param {string} className 
 */
const addClass = (element, className) => {
  if(!element.classList.contains(className))
    element.classList.add(className)
}


const thumnailImages = Array.from(document.getElementsByClassName('p--featured--list--item'))
thumnailImages.forEach(element => {
  element.addEventListener('click', e => {
    const id = e.target.id
    const childrens = Array.from(e.target.parentElement.parentElement.children)
    childrens.find(e => e.getAttribute('aria-current') === 'true').setAttribute('aria-current','false')
    childrens.find(e => e.getAttribute('data-thumbnail-id') === id).setAttribute('aria-current','true')
  })
})


const searchFormContainer = document.getElementById('search-form-container')
const handleDisplaySearchForm = e => {
  if(searchFormContainer) {
    if(searchFormContainer.classList.contains('display-search-form'))
    searchFormContainer.classList.remove('display-search-form')
    else
    searchFormContainer.classList.add('display-search-form')
  }
}
const searchFormCloseButton = document.getElementById('search-form-close-button')
const searchFormDisplayButton = document.getElementById('search-form-display-button')
if(searchFormCloseButton) searchFormCloseButton.addEventListener('click', handleDisplaySearchForm)
if(searchFormDisplayButton) searchFormDisplayButton.addEventListener('click', handleDisplaySearchForm)

